var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container py-5"},[_c('div',{staticClass:"listings"},_vm._l((_vm.auctions),function(auction){return _c('auction',{key:auction.id,attrs:{"auction":auction,"is-logged":_vm.isLogged}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }